import { nanoid } from 'nanoid';

import request from "../web-sh/src/utils/request";
import auth from '../web-sh/src/services/auth';
import global from "../config/global";
import common from '../utils/common';
import coreServices from "./core";

function random_string() {
  return nanoid()
}

async function redirect_login() {
  await common.updateUnlockMethod(null);
  await coreServices.lock();
  const currentPage = common.getRouterByLocation(global.location)
  let isAdmin = !!global.routers.ADMIN_ROUTERS.find((r) => r.name === currentPage?.name)
  const accessToken = await common.getAccessToken();
  if (accessToken) {
    if (!currentPage?.not_auth && currentPage?.name !== global.keys.LOCK) {
      global.navigate(global.keys.LOCK, {}, { return_url: encodeURIComponent(isAdmin ? `${global.location.pathname}${global.location.search}` : '/') })
    }
  } else {
    global.navigate(global.keys.LOGIN)
  }
}

async function locker_access_token() {
  return await request({
    url: global.endpoint.ACCESS_TOKEN,
    method: "post",
    data: {
      SERVICE_SCOPE: global.constants.SERVICE_SCOPE,
      SERVICE_URL: "/sso"
    }
  });
}

async function lock() {
  common.removeIsUnlocked();
  window.location.reload();
}

async function logout(isLogoutId = false) {
  const accessToken = await common.getAccessToken();
  if (accessToken && isLogoutId) {
    try {
      await request({
        url: global.endpoint.LOGOUT,
        method: 'post',
      })
    } catch (error) {
    }
  }
  await coreServices.logout();
  await common.updateUnlockMethod(null);
  await common.updateToken(null);
  common.removeCsLockerToken();
  common.removeIsUnlocked();
  window.location.replace(`${global.urls.LANDING_URL}/passwords?logout=1`)
}

auth.redirect_login = redirect_login;
auth.logout = logout;

export default {
  ...auth,
  locker_access_token,
  random_string,
  lock,
};
